import IndividualTable from '../../../IndividualTable';
import { sampleData } from "../../sampleData";

const Distance145 = () => {
  let winners = ["69", "21", "125", "483", '33', "115", "152", "118"];
  return <IndividualTable matchType={"16"} gender="M" event="145" subTitle="Kungdo" data={sampleData} topRankCount="8" winners={winners} />;
};
export default Distance145;
